<template>
  <div class="chat-process">
    <el-divider content-position="left">目标/过程/结果统计表</el-divider>
    <div style="margin-bottom: 0.4rem">
      <el-collapse accordion v-model="activeOpen">
        <el-collapse-item>
          <template slot="title">高级筛选</template>
          <el-row :span="24" style="display: flex; align-items: center">
            <el-col :span="2">统计时间</el-col>
            <el-col :span="6">
              <el-date-picker
                v-model="searchArr.search_time"
                type="date"
                size="mini"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-col>
            <!-- <el-col :span="2" :offset="2">选择角色</el-col>
                            <el-col :span="4">
                            <el-select :filterable="true" collapse-tags v-model="searchArr.role" placeholder="请选择角色" size="mini" clearable>
                                <el-option v-for="(item, index) in roles" :key="index" :label="item.role_name" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-col> -->
            <el-col :span="2" :offset="2">考核人员</el-col>
            <el-col :span="4">
              <el-cascader
                style="width: 100%"
                v-model="searchArr.executor"
                placeholder="请选择服务人员"
                :options="personnelLists"
                size="mini"
                :props="{ expandTrigger: 'hover' }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-col>
            <!-- </el-row> -->
            <!-- <el-row :span="24" style="display: flex;align-items: center;margin-top: .4rem;">
                      <el-col :span="3" >是否包含离职人员</el-col>
                      <el-col :span="3">
                        <el-radio-group v-model="searchArr.is_position" size="mini">
                          <el-radio-button label="1">是</el-radio-button>
                          <el-radio-button label="0">否</el-radio-button>
                        </el-radio-group>
                      </el-col>
                    </el-row> -->
          </el-row>
          <el-row style="text-align: center; margin-top: 0.4rem">
            <el-col>
              <el-button type="primary" size="mini" @click="handleASearSub"
                >查询</el-button
              >
              <el-button type="danger" size="mini" @click="handleASearchClear"
                >清除</el-button
              >
            </el-col>
          </el-row>
        </el-collapse-item>
      </el-collapse>
    </div>
    <el-row :gutter="24">
      <el-col :span="12">
        <el-card shadow="always">
          <div class="info-style">注册信息表：{{ regInfoExcelTotal }}</div>
          <div class="info-style">新增代账：{{ newAgentTotal }}</div>
          <div class="info-style">今日业绩：{{ todayAmountTotal }}</div>
          <div>代账续费目标：{{ agentFeeTotal }}</div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="always">
          <div style="display: flex; justify-content: space-between">
            <div>
              <div class="info-style">云上公司注册订单沟通：{{ cloudRegCheckTotal }}</div>
              <div class="info-style">代账续费沟通：{{ agentFeeCheckTotal }}</div>
              <div class="info-style">线索沟通考核：{{ clueCheckTotal }}</div>
              <div>客户（会员）沟通：{{ customerCheckTotal }}</div>
            </div>
            <div>
              <div>公司沟通考核：{{ companyCheckTotal }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row style="margin-top: 0.2rem">
      <el-col>
        <span>考核日期：{{ checkTime }}</span>
      </el-col>
    </el-row>
    <div style="width: 100%">
      <el-table
        :data="process_targets"
        style="width: 100%; margin-top: 10px"
        height="470"
        v-if="!loading"
        border
        v-cloak
        :header-cell-style="{
          background: '#ecf4ff',
          color: '#333',
          fontWeight: '900',
          fontSize: '0.28rem',
        }"
      >
        <el-table-column label="考核人员" width="100" fixed>
          <template slot-scope="scope">
            <el-link
              v-if="roleAuth === true && todayFlag === true"
              type="primary"
              :underline="false"
              style="font-size: 0.28rem"
              @click="handleGoal(scope.row)"
              >{{ scope.row.user_name }}</el-link
            >
            <span v-else>{{ scope.row.user_name }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="考核时间" width="100" fixed>
          <template slot-scope="scope">
            <span>{{ scope.row.check_date }}</span>
          </template>
        </el-table-column> -->
        <template v-if="goalDynamicColumns.length > 0">
          <el-table-column
            v-for="(title, index) in goalDynamicColumns"
            :label="title.check_title"
            :key="index + 99"
            width="180"
            :prop="title.goal_res"
          >
            <template slot-scope="scope">
              <div
                style="font-size: 14px"
                :class="{
                  reached:
                    parseInt(
                      scope.row.goal_res[title.goal_res.split('.')[1]].split(' / ')[0]
                    ) >=
                    parseInt(
                      scope.row.goal_res[title.goal_res.split('.')[1]].split(' / ')[1]
                    ),
                  'not-reached':
                    parseInt(
                      scope.row.goal_res[title.goal_res.split('.')[1]].split(' / ')[0]
                    ) <
                    parseInt(
                      scope.row.goal_res[title.goal_res.split('.')[1]].split(' / ')[1]
                    ),
                }"
              >
                <span>{{
                  title.goal_res && scope.row.goal_res
                    ? scope.row.goal_res[title.goal_res.split(".")[1]]
                    : "0/0"
                }}</span>
              </div>
            </template>
          </el-table-column>
        </template>
        <template v-else>
          <el-table-column width="500" label="业绩目标"></el-table-column>
        </template>
        <template v-if="dynamicColumnsValue.length > 0">
          <el-table-column
            v-for="(title, index) in dynamicColumnsValue"
            :label="title.process_title"
            :key="index"
            width="180"
            :prop="title.process"
          >
            <template slot-scope="scope">
              <div
                style="font-size: 14px"
                :class="{
                  reached:
                    parseInt(
                      scope.row.process[title.process.split('.')[1]].split(' / ')[0]
                    ) >=
                    parseInt(
                      scope.row.process[title.process.split('.')[1]].split(' / ')[1]
                    ),
                  'not-reached':
                    parseInt(
                      scope.row.process[title.process.split('.')[1]].split(' / ')[0]
                    ) <
                    parseInt(
                      scope.row.process[title.process.split('.')[1]].split(' / ')[1]
                    ),
                }"
              >
                <span>{{ scope.row.process[title.process.split(".")[1]] }}</span>
              </div>
            </template>
          </el-table-column>
        </template>
        <template v-else>
          <el-table-column label="过程目标"></el-table-column>
        </template>

        <!-- <el-table-column label="操作">
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="编辑"
                  placement="top"
                >
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-edit"
                    circle
                  >
                  </el-button>
                </el-tooltip>
            </template>
          </el-table-column> -->
      </el-table>

      <div v-else class="loading-placeholder">加载中，请稍后...</div>
    </div>

    <el-drawer
      title="修改目标值"
      :visible.sync="handleGoalDrawer"
      direction="rtl"
      :before-close="handleGoalBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row :span="24" style="margin-bottom: 1rem">
          <el-col :span="12">考核人：{{ goalForm.user_name }}</el-col>
          <el-col :span="12">考核日期：{{ goalForm.check_date }}</el-col>
        </el-row>

        <el-form :model="goalForm" ref="goalForm" label-width="100px">
          <el-form-item label="注册信息表">
            <el-input
              size="mini"
              type="number"
              min="1"
              v-model="goalForm.reg_info_excel"
            ></el-input>
          </el-form-item>
          <el-form-item label="新增代账">
            <el-input
              size="mini"
              type="number"
              min="1"
              v-model="goalForm.new_agent"
            ></el-input>
          </el-form-item>
          <el-form-item label="今日业绩">
            <el-input
              size="mini"
              type="number"
              min="1"
              v-model="goalForm.today_amount"
            ></el-input>
          </el-form-item>
          <el-form-item label="代账续费目标">
            <el-input
              size="mini"
              type="number"
              min="1"
              v-model="goalForm.agent_xf_goal"
            ></el-input>
          </el-form-item>
          <el-form-item label="云上公司注册订单沟通">
            <el-input
              size="mini"
              type="number"
              min="1"
              v-model="goalForm.cloud_com_reg_chat"
            ></el-input>
          </el-form-item>
          <el-form-item label="代账续费沟通">
            <el-input
              size="mini"
              type="number"
              min="1"
              v-model="goalForm.agent_xf_chat"
            ></el-input>
          </el-form-item>
          <el-form-item label="线索沟通考核">
            <el-input
              size="mini"
              type="number"
              min="1"
              v-model="goalForm.clue_chat"
            ></el-input>
          </el-form-item>
          <el-form-item label="客户（会员沟通）">
            <el-input
              size="mini"
              type="number"
              min="1"
              v-model="goalForm.customer_chat"
            ></el-input>
          </el-form-item>
          <el-form-item label="公司沟通">
            <el-input
              size="mini"
              type="number"
              min="1"
              v-model="goalForm.com_chat"
            ></el-input>
          </el-form-item>
          <el-form-item label="IM线索盘点">
            <el-input
              size="mini"
              type="number"
              min="1"
              v-model="goalForm.im_clue_chat"
            ></el-input>
          </el-form-item>
          <el-form-item label="IM会员沟通">
            <el-input
              size="mini"
              type="number"
              min="1"
              v-model="goalForm.im_vip_chat"
            ></el-input>
          </el-form-item>
          <el-form-item label="IM引导客户注册小程序">
            <el-input
              size="mini"
              type="number"
              min="1"
              v-model="goalForm.im_fllow_chat"
            ></el-input>
          </el-form-item>
          <div style="text-align: right">
            <el-button type="primary" size="mini" @click="submitForm('goalForm')"
              >保存</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';

export default {
  name: "ProcessTarget",
  data() {
    return {
      activeOpen: "",
      searchArr: {
        search_time: "",
        executor: null,
        role: null,
        is_position: null,
      },
      npage: 1,
      checkInPerPage: 15,
      total: null,
      process_targets: [],
      personnel: [],
      personnelLists: [],
      roles: [],
      dynamicColumnsValue: [],
      goalDynamicColumns: [],
      loading: true,
      regInfoExcelTotal: 0,
      newAgentTotal: 0,
      todayAmountTotal: 0,
      agentFeeTotal: 0,
      cloudRegCheckTotal: 0,
      agentFeeCheckTotal: 0,
      clueCheckTotal: 0,
      customerCheckTotal: 0,
      companyCheckTotal: 0,
      handleGoalDrawer: false,
      goalForm: {
        user_id: "",
        user_name: "",
        check_date: "",

        reg_info_excel: 0,
        new_agent: 0,
        today_amount: 0,
        agent_xf_goal: 0,
        cloud_com_reg_chat: 0,
        agent_xf_chat: 0,
        clue_chat: 0,
        customer_chat: 0,
        com_chat: 0,
        im_clue_chat: 0,
        im_vip_chat: 0,
        im_fllow_chat: 0,
      },
      roleAuth: false,
      todayFlag: false,
      checkTime: "",
    };
  },
  created() {
    // 获取过程动态配置列
    this.dynamicColumns();
    // this.getTotalData()
    // this.goalDynamicColumns()
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickCollapseOutSide);
  },
  mounted() {
    this.loadTable();
    document.addEventListener("click", this.handleClickCollapseOutSide);
  },
  computed: {
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    loadTable() {
      this.loading = true;
      this.$axios
        .get("api/admin/check_setting/get_process_target", {
          params: {
            page: this.npage,
            perpage: this.checkInPerPage,
            searchItem: this.searchArr,
          },
        })
        .then(({ data }) => {
          if (data.code === 0) {
            // console.log(data);return;
            this.process_targets = data.data.list;
            this.personnel = data.data.personnel;
            this.personnelLists = data.data.personnelLists;
            this.roleAuth = data.data.roleAuth;
            this.todayFlag = data.data.todayFlag;
            this.checkTime = data.data.searchTime;
            // this.roles = data.data.roles
            this.total = this.process_targets.length;
            // console.log(this.process_targets);return;
            this.calculateSummaryData();
          }
        })
        .finally(() => {
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          // this.$message.error('数据加载失败，请稍后再试！')
        });
    },
    handleClickCollapseOutSide(event) {
      const elCollapse = this.$el.querySelector(".el-collapse");
      if (elCollapse && !elCollapse.contains(event.target)) {
        this.activeOpen = "";
      }
    },
    calculateSummaryData() {
      // 初始化所有汇总数据为 0
      this.regInfoExcelTotal = 0;
      this.newAgentTotal = 0;
      this.todayAmountTotal = 0;
      this.agentFeeTotal = 0;
      this.cloudRegCheckTotal = 0;
      this.agentFeeCheckTotal = 0;
      this.clueCheckTotal = 0;
      this.customerCheckTotal = 0;
      this.companyCheckTotal = 0;

      if (this.total > 0) {
        for (let index = 0; index < this.process_targets.length; index++) {
          const element = this.process_targets[index];
          // 目标
          this.regInfoExcelTotal += parseInt(
            element.goal_res.check_title7.split(" / ")[0]
          );
          this.newAgentTotal += parseInt(element.goal_res.check_title8.split(" / ")[0]);
          this.todayAmountTotal += parseInt(
            element.goal_res.check_title9.split(" / ")[0]
          );
          this.agentFeeTotal += parseInt(element.goal_res.check_title13.split(" / ")[0]);

          // 过程
          this.cloudRegCheckTotal += parseInt(
            element.process.process_value5.split(" / ")[0]
          );
          this.agentFeeCheckTotal += parseInt(
            element.process.process_value6.split(" / ")[0]
          );
          this.clueCheckTotal += parseInt(element.process.process_value7.split(" / ")[0]);
          this.customerCheckTotal += parseInt(
            element.process.process_value8.split(" / ")[0]
          );
          this.companyCheckTotal += parseInt(
            element.process.process_value9.split(" / ")[0]
          );
        }
      }
    },
    handleGoal(row) {
      this.goalForm.user_id = row.user_id;
      this.goalForm.user_name = row.user_name;
      this.goalForm.check_date = row.check_date;
      this.goalForm.reg_info_excel = row.goal_res.check_title7.split(" / ")[1];
      this.goalForm.new_agent = row.goal_res.check_title8.split(" / ")[1];
      this.goalForm.today_amount = row.goal_res.check_title9.split(" / ")[1];
      this.goalForm.agent_xf_goal = row.goal_res.check_title13.split(" / ")[1];

      this.goalForm.cloud_com_reg_chat = row.process.process_value5.split(" / ")[1];
      this.goalForm.agent_xf_chat = row.process.process_value6.split(" / ")[1];
      this.goalForm.clue_chat = row.process.process_value7.split(" / ")[1];
      this.goalForm.customer_chat = row.process.process_value8.split(" / ")[1];
      this.goalForm.com_chat = row.process.process_value9.split(" / ")[1];
      this.goalForm.im_clue_chat = row.process.process_value10.split(" / ")[1];
      this.goalForm.im_vip_chat = row.process.process_value11.split(" / ")[1];
      this.goalForm.im_fllow_chat = row.process.process_value12.split(" / ")[1];
      this.handleGoalDrawer = true;
    },
    submitForm() {
      this.$axios
        .post("/api/admin/check_setting/handle_update_goal", { params: this.goalForm })
        .then(({ data }) => {
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.handleGoalDrawer = false;
            this.loadTable();
          } else {
            this.$message.success(data.msg);
          }
        });
    },

    handleGoalBeforeClose(done) {
      done();
    },
    // getTotalData() {
    //   this.$axios.get('api/admin/check_setting/get_check_total_data', {
    //     params: {
    //         searchItem: this.searchArr
    //       }
    //   }).then(({data}) => {
    //     if (data.code === 0) {

    //     }
    //   })
    // },
    dynamicColumns() {
      this.$axios
        .get("api/admin/check_setting/get_process_column", {
          params: {
            searchItem: this.searchArr,
          },
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.dynamicColumnsValue = data.data.dynamicColumns;
            this.goalDynamicColumns = data.data.goalGynamicColumns;
          }
        });
    },
    handleCurrentChange(val) {
      this.npage = val;
      this.dynamicColumns();
      this.loadTable();
    },
    handleSizeChange(val) {
      this.checkInPerPage = val;
      this.dynamicColumns();
      this.loadTable();
    },
    handleASearSub() {
      this.npage = 1;
      this.dynamicColumns();
      this.activeOpen = "";
      this.loadTable();
    },
    handleASearchClear() {
      this.npage = 1;
      this.searchArr.search_time = "";
      this.searchArr.executor = null;
      this.searchArr.role = null;
      this.searchArr.is_position = null;
      this.dynamicColumns();
      this.activeOpen = "";
      this.loadTable();
    },
    filterOptions(node, keyword) {
  return filterKeywordOptions(node, keyword);
}
  },
};
</script>

<style scoped>
.chat-process {
  /* margin-left: 3.6rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
  .info-style {
    margin-bottom: 0.2rem;
  }
}

.loading-placeholder {
  text-align: center;
  padding: 20px;
}

.reached {
  border-radius: 4px;
  text-align: center;
  /* background-color: #faecd8; */
  border-color: #faecd8;
  color: green;
}
.not-reached {
  border-radius: 4px;
  border-color: #fde2e2;
  /* background-color: #fef0f0; */
  text-align: center;
  color: red;
}

.m-tabs-content {
  padding: 0 0.2rem 0 0.4rem;

  .m-label {
    line-height: 0.64rem;
  }

  .el-row {
    margin-bottom: 0.4rem;
  }

  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }

  .tabs-title {
    color: #409eff;
  }
}

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

.mt-10 {
  margin-top: 0.2rem;
}

.tr {
  text-align: right;
}

.check-goal {
  display: inline-block;

  .goal-styl {
    /* display: block; */
    /* height: 1rem; */
    border: 1px solid #d9ecff;
    border-radius: 4px;
    padding: 0.05rem 0.4rem;
    margin: 0 0.1rem;
    background-color: #ecf5ff;
    color: #409eff;
    box-sizing: border-box;
    white-space: nowrap;
  }
}

.process-goal {
  display: inline-block;

  .process-styl {
    /* border: 1px solid #ccc; */
    border-radius: 4px;
    padding: 0.05rem 0.4rem;
    margin: 0 0.1rem;
    background-color: #409eff;
    color: #fff;
  }
  .active-styl {
    /* border: 1px solid #ccc; */
    border-radius: 25px;
    padding: 0.05rem 0.4rem;
    margin: 0 0.1rem;
    background-color: orange;
    color: #fff;
  }
}

.goal-res {
  display: inline-block;
  .goal-restyl {
    border: 1px solid #e1f3d8;
    border-radius: 4px;
    padding: 0.05rem 0.4rem;
    margin: 0 0.1rem;
    background-color: #f0f9eb;
    color: #67c23a;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/data_analysis/ProcessTarget.vue